import { AxiosInstance } from 'axios';

import { ITargetCheckSettings } from './getSettings';

import { insertId } from '../../insertId';
import { cancellable } from '../../cancellable';
import { toResponse } from '../../genericToResponse';

export default (api: AxiosInstance, url: string) => (
  id: number,
  settings: ITargetCheckSettings
) => {
  const urlWithId = insertId(url, id);
  return cancellable<ITargetCheckSettings>(
    (cancelOptions: any) => api.post(urlWithId, settings, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/link/targetCheck/updateSettings.ts